/**
 * @file The one reactive read of "is the approval being written right now?",
 * shared by every editable Mapping Review surface. `approve()` snapshots the
 * edited document once and then runs an async Storage-save → POST; for that
 * whole window the panel must freeze its inputs, or edits made after the
 * snapshot mutate the live proxy and are silently lost (the data-loss window
 * the critique flagged HIGH). Rather than thread a `submitting` prop down the
 * tree, each surface calls this hook and disables its own controls — granular
 * Valtio subscriptions, no parent/child coordination. True while either the
 * session Storage write (`session.saving`) or the resolve POST
 * (`agentApprovalState.submitting`) is in flight.
 */
import { useSnapshot } from 'valtio';
import { agentApprovalState } from '../agentApprovalState';
import { mappingReviewState } from './mappingReviewState';

export function useMappingReviewSubmitting(): boolean {
  const panelSnap = useSnapshot(mappingReviewState);
  const approvalSnap = useSnapshot(agentApprovalState);
  return Boolean(panelSnap.session?.saving) || approvalSnap.submitting;
}
